import { Component, Input, OnInit } from '@angular/core';
import { environment } from '@environment';
import { ToLocalStringPipe } from '@utils/pipes';
import { degrees, PDFDocument, rgb, StandardFonts } from 'pdf-lib';

@Component({
    selector: 'app-certificates',
    templateUrl: './certificates.component.html',
    standalone: false
})
export class CertificatesComponent implements OnInit {
  @Input()
  customerName: string;

  @Input()
  meteringPointName: string;

  @Input()
  keyValueCO2: string;

  @Input()
  yearOfCertificate: string;

  keyValueCO2Display = '-';

  constructor(private toLocal: ToLocalStringPipe) {
  }

  ngOnInit(): void {
  }

  async getCert() {

    const url = `${environment.originUrl}/certifikat-mall.pdf`;
    const existingPdfBytes = await fetch(url).then(res => res.arrayBuffer());
    const pdfDoc = await PDFDocument.load(existingPdfBytes);

    const form = pdfDoc.getForm();
    // const fields = form.getFields();
    // fields.forEach(field => {
    //   const name = field.getName();
    //   console.log('Field name:', name);
    // });

    const nameField = form.getTextField('CustomerName');
    nameField.setText(this.customerName);

    const facilityField = form.getTextField('FacilityName');
    facilityField.setText(this.capitalizeFirstLetter(this.meteringPointName));
    const co2Field = form.getTextField('CO2');

    this.keyValueCO2Display = this.keyValueCO2 ? this.toLocal.transform(this.keyValueCO2) : '-';
    co2Field.setText(this.keyValueCO2Display + ' ton koldioxidekvivalenter');
    const yearField = form.getTextField('Year');
    yearField.setText(this.yearOfCertificate + '.');

    const pdfBytes = await pdfDoc.save();

    const blob = new Blob([pdfBytes], { type: 'text/pdf' });
    const newUrl = window.URL.createObjectURL(blob);
    let a = document.createElement('a');
    a.href = newUrl;
    a.target = 'blank';
    a.download = 'Certifikat.pdf';
    document.body.appendChild(a);
    a.click();

    setTimeout(function () {
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    }, 0);

  }

  capitalizeFirstLetter(string) {
    if (string !== null) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
    return string;
  }

}
